import {
  Component,
} from '@angular/core';
import { environment } from '@env//environment.local';
import { CalculateDiroOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/calculate-diro/calculate-diro-wrapper.component';

@Component({
  selector: 'app-calculate-diro-mobile',
  templateUrl: './calculate-diro-mobile.component.html',
  styleUrls: ['./calculate-diro-mobile.component.scss'],
})
export class CalculateDiroMobileComponent extends CalculateDiroOpenQuoteWrapper {}

